<div class="redirect-top">
    <img
        src="../../assets/images/logo.png"
        class="redirect-logo"
        alt="CLARK logo" />
    <strong><h1 tabindex="0" class="huge">Redirecting...</h1></strong>
    <p tabindex="0" class="message">Please wait while we redirect you...</p>
    <a tabindex="0" routerLink="" class="message">Back to Home</a>
</div>
